export default __webpack_public_path__ + "static/media/link-circle.30c0924b.svg";